import { render, staticRenderFns } from "./announcementMaintain.vue?vue&type=template&id=f1f38422&"
import script from "./announcementMaintain.vue?vue&type=script&lang=js&"
export * from "./announcementMaintain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports